import { useEffect, useState } from "react";
import { SkyButton } from "@skypointcloud/skypoint-ui";
import { X as DismissIcon } from "lucide-react";
import { watchForNewDeployOnFocus } from "../../utils/versionCheck";

/**
 * The "a new version is available" prompt, matching skyAdvisor and
 * skySchedule.
 *
 * A tab left open across a deploy keeps running the bundle it first loaded,
 * so it quietly behaves like an older version of itself until someone
 * reloads. This offers the reload rather than performing it: a recruiter
 * mid-way through a candidate note should not have the page pulled out from
 * under them.
 *
 * Checked on tab focus only, so there is no background polling, and the check
 * no-ops entirely in dev.
 */
export function NewVersionBanner() {
  const [available, setAvailable] = useState(false);

  useEffect(() => watchForNewDeployOnFocus(() => setAvailable(true)), []);

  if (!available) return null;

  return (
    <div
      role="status"
      className="flex items-center justify-center gap-3 border-b border-amber-200 dark:border-amber-800/60 bg-amber-50 dark:bg-amber-950/40 px-4 py-1.5 text-sm text-amber-900 dark:text-amber-300"
    >
      <span>A new version of skyHire is available.</span>
      <SkyButton
        appearance="primary"
        size="small"
        onClick={() => window.location.reload()}
      >
        Refresh
      </SkyButton>
      <SkyButton
        appearance="transparent"
        size="small"
        icon={DismissIcon}
        aria-label="Dismiss"
        onClick={() => setAvailable(false)}
      />
    </div>
  );
}

export default NewVersionBanner;
